import React, { FC, useEffect, useRef, useState } from 'react';
import { Row } from 'antd';
import { ProtectedImageThumbnails } from '../protected_image_thumbnails/ProtectedImageThumbnails';
import { ROLE_TYPES } from '../../utils/DataConstants';

export const ImageRow = ({ photoStrings }) => {
	const imageRowRef = useRef();
	const [imageRowWidth, setImageRowWidth] = useState(0);

	useEffect(() => {
		const updateWidth = () => {
			if (imageRowRef.current) {
				setImageRowWidth(imageRowRef.current.offsetWidth || 300);
			}
		};

		updateWidth();

		window.addEventListener('resize', updateWidth);
		return () => {
			window.removeEventListener('resize', updateWidth);
		};
	}, [photoStrings.length]);

	const imageGap = 8;
	const imageWidth = 300;
	const imageRowPadding = 8;

	const showNumberOfImages = Math.floor(imageRowWidth / (imageWidth + imageGap + 8)) || 3;

	if (!photoStrings || photoStrings.length === 0) return null;

	return (
		<div ref={imageRowRef} style={{ width: '100%' }}>
			<Row>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						flex: '1 1 50%',
						justifyContent: 'center',
						boxSizing: 'border-box',
						paddingLeft: imageRowPadding,
						paddingTop: imageRowPadding,
						paddingBottom: imageRowPadding,
					}}
				>
					<div className="expanded_rowSubTitle">Images</div>
					<ProtectedImageThumbnails
						style={{ marginTop: 4, cursor: 'pointer', gap: imageGap }}
						imageWidth={imageWidth}
						imageHeight={imageWidth}
						photoStrings={photoStrings}
						role={ROLE_TYPES.BUYER}
						showNumberOfImages={showNumberOfImages}
					/>
				</div>
			</Row>
		</div>
	);
};
